import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';

interface LanguageStats {
  modelLang: string;
  totalDomainInLang: number;
}

const ModelLangStatsChart: React.FC = () => {
  const [langData, setData] = useState<LanguageStats[]>([]);

  useEffect(() => {
    fetch('/api/domain-models/modelLangStats')
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then((data: LanguageStats[]) => {
            setData(data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
}, []);

return (
  <div>
  <table>
    <thead>
      <tr>
        <th>Model Language</th>
        <th>Total no. of Domains</th>
      </tr>
    </thead>
    <tbody>
      {langData.map((score, index) => (
        <tr key={index}>
          <td>{score.modelLang}</td>
          <td>{score.totalDomainInLang}</td>
        </tr>
      ))}
    </tbody>
  </table>
  </div>
);
};

export default ModelLangStatsChart;
